import { Check } from 'lucide-react';

import { Button } from '@src/components/ui';

import { Modal } from './controls';


/** Pre-redirect "Connect your eBay account" modal (.pen R2CDd stage 2). A short
 * explainer + a three-item checklist of what granting access entails, then a
 * primary "Continue to eBay" CTA that kicks off the OAuth round-trip. Reuses the
 * shared `Modal` shell. `busy` reflects the in-flight authorize-url request. */
function EbayConnectModal({ busy, onClose, onContinue }) {
  const items = [
    'Grant AutoOrbit access to your eBay account',
    'Keep your business policies in eBay',
    'We redirect you to eBay to finish sign-in',
  ];

  return (
    <Modal
      title="Connect your eBay account"
      subtitle="We'll send you to eBay to grant AutoOrbit access. Your eBay password is never shared with us."
      onClose={onClose}
      footer={(
        <>
          <Button type="button" variant="ghost" onClick={onClose}>
            Cancel
          </Button>

          <Button type="button" loading={busy} onClick={onContinue}>
            Continue to eBay
          </Button>
        </>
      )}
    >
      <ul className="flex flex-col gap-2.5 py-1">
        {items.map((item) => (
          <li key={item} className="flex items-center gap-3 text-table text-ink-muted">
            <span className="grid size-[26px] shrink-0 place-items-center rounded-full bg-primary-soft text-primary">
              <Check className="size-[15px]" strokeWidth={3} />
            </span>

            <span>{item}</span>
          </li>
        ))}
      </ul>
    </Modal>
  );
}

EbayConnectModal.displayName = 'EbayConnectModal';
export default EbayConnectModal;
